export default __webpack_public_path__ + "static/media/Title.2dfa2307.svg";